function toggleMenu(el) {
    el.classList.toggle('active');
    var nav = document.getElementById('mobileNav');
    nav.classList.toggle('open');
  }
  function closeMobileNav() {
    document.getElementById('mobileNav').classList.remove('open');
    document.querySelector('.hamburger').classList.remove('active');
  }

  function toggleFaq(btn) {
    var item = btn.parentElement;
    var isOpen = item.classList.contains('open');
    document.querySelectorAll('.faq-item').forEach(function(i){ i.classList.remove('open'); });
    if (!isOpen) item.classList.add('open');
  }

  function downloadTechnicalPass(event) {
    event.preventDefault();
    var link = event.currentTarget;
    var url = link.href;
    var filename = link.getAttribute('download') || 'download.pdf';

    fetch(url)
      .then(function(response) {
        if (!response.ok) throw new Error('Download failed');
        return response.blob();
      })
      .then(function(blob) {
        var blobUrl = URL.createObjectURL(blob);
        var tempLink = document.createElement('a');
        tempLink.href = blobUrl;
        tempLink.download = filename;
        document.body.appendChild(tempLink);
        tempLink.click();
        document.body.removeChild(tempLink);
        URL.revokeObjectURL(blobUrl);
      })
      .catch(function(error) {
        console.error(error);
        window.open(url, '_blank');
      });
  }

  var buyImages = [
  'https://cdn.shopify.com/s/files/1/1050/0882/4658/files/Webshop_1.png?v=1776098017',
  'https://cdn.shopify.com/s/files/1/1050/0882/4658/files/Webshop_2_transparent.png?v=1777496890',
  'https://cdn.shopify.com/s/files/1/1050/0882/4658/files/Webshop_3_transparent.png?v=1777496890',
  'https://cdn.shopify.com/s/files/1/1050/0882/4658/files/Webshop_2_transparent.png?v=1777496890'
];

  var buyCurrent = 0;

  function buySetImg(i, el) {
    buyCurrent = i;
    document.getElementById('buyMainImg').src = buyImages[i];
    document.querySelectorAll('.buy-thumb').forEach(function(t){ t.classList.remove('active'); });
    if (el) el.classList.add('active');
    else document.querySelectorAll('.buy-thumb')[i].classList.add('active');
  }

  function buyNavigate(dir) {
    buyCurrent = (buyCurrent + dir + buyImages.length) % buyImages.length;
    buySetImg(buyCurrent, null);
  }

  function lbOpen(i) {
    buyCurrent = i;
    document.getElementById('lb-img').src = buyImages[buyCurrent];
    document.getElementById('lb').classList.add('lb-open');
    document.body.style.overflow = 'hidden';
  }

  function lbClose() {
    document.getElementById('lb').classList.remove('lb-open');
    document.body.style.overflow = '';
  }

  function lbNav(dir) {
    buyCurrent = (buyCurrent + dir + buyImages.length) % buyImages.length;
    document.getElementById('lb-img').src = buyImages[buyCurrent];
    buySetImg(buyCurrent, null);
  }

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && document.getElementById('lb').classList.contains('lb-open')) {
      lbClose();
    }
  });

  var buyQty = 1;
  function buyChQty(d) {
    buyQty = Math.max(1, buyQty + d);
    document.getElementById('buyQtyNum').textContent = buyQty;
  }

  function buyAddToCart() {
    var btn = document.getElementById('buyCartBtn');
    var variantId = btn.getAttribute('data-variant-id');

    if (!variantId) {
      console.error('AQUAFIT: buy button is missing a variant id');
      return;
    }

    var originalText = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Tilføjer...';

    fetch(Theme.routes.cart_add_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: buyQty }] }),
    })
      .then(function(response) {
        return response.json().then(function(data) {
          if (!response.ok) throw new Error(data.description || data.message || 'Cart add failed');
          return data;
        });
      })
      .then(function() {
        btn.textContent = 'Tilføjet til kurv ✓';
        btn.classList.add('added');
        window.location.href = '/checkout';
      })
      .catch(function(error) {
        console.error(error);
        btn.disabled = false;
        btn.textContent = originalText;
        alert('Der opstod en fejl - produktet kunne ikke tilføjes til kurven. Prøv igen.');
      });
  }
    /* ── Zoom ── */
function initZoom() {
  var img = document.getElementById('buyMainImg');
  var container = document.querySelector('.buy-gallery-main');

  container.addEventListener('mousemove', function(e) {
    var rect = container.getBoundingClientRect();
    var x = ((e.clientX - rect.left) / rect.width) * 100;
    var y = ((e.clientY - rect.top) / rect.height) * 100;
    img.style.transformOrigin = x + '% ' + y + '%';
    img.style.transform = 'scale(2.5)';
  });

  container.addEventListener('mouseleave', function() {
    img.style.transform = 'scale(1)';
    img.style.transformOrigin = 'center center';
  });
}


  document.addEventListener('DOMContentLoaded', initZoom);
  
/* Animations */
document.addEventListener('DOMContentLoaded', function () {
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15 });

  document.querySelectorAll('.animate-on-scroll, .animate-from-left, .animate-from-right').forEach(el => {
    const rect = el.getBoundingClientRect();
    if (rect.top < window.innerHeight && rect.bottom > 0) {
      el.classList.add('is-visible');
    } else {
      observer.observe(el);
    }
  });
});
